
import React from 'react';
import { ErrorBoundary } from '@/components/error-handling/ErrorBoundary';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface AutomationErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const AutomationErrorFallback: React.FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <Alert variant="destructive" className="m-4">
    <AlertTriangle className="h-4 w-4" />
    <AlertTitle>Automation Error</AlertTitle>
    <AlertDescription className="mt-2">
      <p className="mb-4">There was an error loading the automation component. Please try again.</p>
      <Button variant="outline" onClick={onRetry} className="flex items-center gap-2">
        <RefreshCw className="h-4 w-4" />
        Retry
      </Button>
    </AlertDescription>
  </Alert>
);

export const AutomationErrorBoundary: React.FC<AutomationErrorBoundaryProps> = ({ 
  children, 
  fallback 
}) => {
  return (
    <ErrorBoundary
      fallback={fallback || <AutomationErrorFallback onRetry={() => window.location.reload()} />}
    >
      {children}
    </ErrorBoundary>
  );
};
